import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css?external';  // eslint-disable-line

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import PhotoIcon from '@material-ui/icons/HowToRegOutlined';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';


class ProfilePhotos extends Component {
  state = {
    modalOpen: false,
    imageIndex: null,
  }

  handleClose = () => {
    this.setState({
      modalOpen: false,
    });
  }

  previewImage = (index) => {
    this.setState({
      modalOpen: true,
      imageIndex: index,
    });
  }

  render() {
    let photos = (
      <div align="center" style={{ paddding: '30px' }}>
        <Typography variant="subheading">No Photos Found</Typography>
      </div>
    );

    const photosArr = [];

    if (this.props.profile.photos.length > 0) {
      photos = this.props.profile.photos.map((photo, index) => {
        const src = constants.BASE_URL + photo.thumbnail;
        photosArr.push(constants.BASE_URL + photo.preview);
        return (
          <Grid
            item
            md={3}
            sm={3}
            xs={6}
            key={photo.id}
            onClick={() => this.previewImage(index)}
          >
            <img alt={photo.id} src={src} className={classes.profilePhoto} />
          </Grid>
        );
      });
    }

    let editButton = null;

    if (this.props.profile.is_editable) {
      editButton = (
        <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => this.props.editProfileSection('photos')}>Edit</Button>
      );
    }

    return (
      <React.Fragment>
        <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
          {editButton}
          <Typography variant="subheading" className={classes.profileSectionTitle}>
            <PhotoIcon className={classes.titleIcon} />
            Photos
          </Typography>
          <br />
          <Grid container spacing={16}>
            {photos}
          </Grid>
        </Paper>
        {this.state.modalOpen && (
          <Lightbox
            mainSrc={photosArr[this.state.imageIndex]}
            nextSrc={photosArr[(this.state.imageIndex + 1) % photosArr.length]}
            prevSrc={photosArr[(this.state.imageIndex + photosArr.length - 1) % photosArr.length]}
            onCloseRequest={() => this.setState({ modalOpen: false })}
            onMovePrevRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + photosArr.length - 1) % photosArr.length,
            })}
            onMoveNextRequest={() => this.setState({
              imageIndex: (this.state.imageIndex + 1) % photosArr.length,
            })}
          />
        )}
      </React.Fragment>
    );
  }
}


export default ProfilePhotos;



// WEBPACK FOOTER //
// ./src/profile/components/ProfilePhotos.js